"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

var _arrowRight = require("@wel-ui/icons/lib/ui/arrow-right");

var _arrowRight2 = _interopRequireDefault(_arrowRight);

var _plus = require("@wel-ui/icons/lib/ui/plus");

var _plus2 = _interopRequireDefault(_plus);

var _utilityClassNames = require("@wel-ui/utility-class-names");

var _utilityClassNames2 = _interopRequireDefault(_utilityClassNames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Link = function Link(_ref) {
  var block = _ref.block,
      children = _ref.children,
      href = _ref.href,
      iconLeft = _ref.iconLeft,
      iconRight = _ref.iconRight,
      newWindow = _ref.newWindow,
      type = _ref.type;

  var getClassName = (0, _utilityClassNames2.default)(Link.displayName);

  var ElementType = href ? "a" : "span";

  var withIcon = iconLeft || iconRight || type !== "inline";

  var linkProps = {
    className: getClassName({
      modifiers: (0, _classnames2.default)({ block: block, iconLeft: iconLeft, withIcon: withIcon }, type)
    })
  };

  var icon = iconRight || iconLeft;

  switch (type) {
    case "action":
      icon = _react2.default.createElement(_plus2.default, null);
      break;
    case "primary":
    case "secondary":
      icon = _react2.default.createElement(_arrowRight2.default, null);
      break;
  }

  if (href) {
    linkProps.href = href;

    if (newWindow) {
      linkProps.target = "_blank";
      linkProps.rel = "noopener";
    }
  }

  if (!withIcon) {
    // Deliberately without descendants
    return _react2.default.createElement(
      ElementType,
      linkProps,
      children
    );
  }

  return _react2.default.createElement(
    ElementType,
    linkProps,
    iconLeft && _react2.default.createElement(
      "span",
      { className: getClassName({ descendantName: "icon" }) },
      icon
    ),
    _react2.default.createElement(
      "span",
      { className: getClassName({ descendantName: "inner" }) },
      children
    ),
    !iconLeft && _react2.default.createElement(
      "span",
      { className: getClassName({ descendantName: "icon" }) },
      icon
    )
  );
};

Link.defaultProps = {
  type: "inline"
};

Link.displayName = "Link";

Link.types = ["primary", "secondary", "action", "inline"];

/* eslint-disable max-len */
Link.propTypes = {
  /**
   * Enable block behaviour.
   */
  block: _propTypes2.default.bool,

  /**
   * Link text.
   */
  children: _propTypes2.default.node.isRequired,

  /**
   * URL for the link.
   */
  href: _propTypes2.default.string,

  /**
   * Arbitary Icon component to display to left of text.
   */
  iconLeft: _propTypes2.default.node,

  /**
   * Arbitary Icon component to display to right of text.
   */
  iconRight: _propTypes2.default.node,

  /**
   * Type of link.
   */
  type: _propTypes2.default.oneOf(Link.types),

  /**
   * Open link in new tab/window.
   */
  newWindow: _propTypes2.default.bool
};
/* eslint-enable max-len */

exports.default = Link;


//////////////////
// WEBPACK FOOTER
// ../node_modules/@wel-ui/component-link/lib/Link.js
// module id = 373
// module chunks = 0